import { fetchCMSData } from "@clients/contentfulClient";
import { mappedFaqUrlStructure } from "@utils/mappers/faqUrlStructureMapper";
import { SiteCacheItem, siteCacheFetch } from "@utils/siteStructureCache";

import { GET_FAQ_STRUCTURE_M } from "queries/global/getFaqStructure.query";
import { UrlStructureItem } from "types/UrlStructureItem";

export const getFaqUrlStructure = async (preview: boolean): Promise<UrlStructureItem[]> => {
  if (preview) {
    return fetchFaqUrlStructure(preview);
  }
  return siteCacheFetch(SiteCacheItem.FAQ_URL_STRUCTURE, () => fetchFaqUrlStructure(preview));
};

const fetchFaqUrlStructure = async (preview: boolean): Promise<UrlStructureItem[]> => {
  const faqs: any = [];

  const getAllFaq = async (limit: number, skip: number) => {
    const { data: faqStructure } = await fetchCMSData(
      GET_FAQ_STRUCTURE_M(preview, limit, skip),
      preview,
    );
    for (const i of faqStructure?.faqCollection?.items) {
      faqs.push(i);
    }
    if (faqStructure?.faqCollection?.total > faqs.length) {
      return await getAllFaq(limit, faqs.length);
    }
    return faqs;
  };

  const allFaq = (await getAllFaq(200, 0)) as Array<any>;
  return mappedFaqUrlStructure(allFaq);
};
